module.exports = __webpack_public_path__ + "as.svg?078ba7453c7f253d3f2ceea4b8b57d37";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/as.svg
// module id = 1231
// module chunks = 0